import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=2ed29808&lang=pug&"
import script from "./LinkButton.vue?vue&type=script&lang=js&"
export * from "./LinkButton.vue?vue&type=script&lang=js&"
import style0 from "./LinkButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed29808')) {
      api.createRecord('2ed29808', component.options)
    } else {
      api.reload('2ed29808', component.options)
    }
    module.hot.accept("./LinkButton.vue?vue&type=template&id=2ed29808&lang=pug&", function () {
      api.rerender('2ed29808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LinkButton.vue"
export default component.exports